import { request } from "./index.js";
import { apiHost, newPlatform, oldPlatform } from "./config.js";
/**
 * 
 * @param {*} params 
 * @returns  草稿列表
 */
// 借款审批单-草稿列表
export async function getLoanApprovalDraftsList(params) {
  return request({
    method: `post`,
    url: `${apiHost}/loanApproval/draftsList`,
    data: { ...params }
  })
}
// 借款审批单-删除草稿
export async function getLoanApprovalDeleteDraft(id) {
  return request({
    method: `DELETE`,
    url: `${apiHost}/loanApproval/deleteDraft?id=${id}`,
  })
}

// 费用报销单-草稿分页列表
export async function getReimbursementDraftsList(params) {
  return request({
    method: `post`,
    url: `${apiHost}/expense/reimbursement/draftsList`,
    data: { ...params }
  })
}
// 费用报销单-删除草稿
export async function getReimbursementDeleteDraft(id) {
  return request({
    method: `DELETE`,
    url: `${apiHost}/expense/reimbursement/deleteDraft?id=${id}`,
  })
}


// 付款申请单-草稿分页列表
export async function getApplicationDraftsList(params) {
  return request({
    method: `post`,
    url: `${apiHost}/payment/application/draftsList`,
    data: { ...params }
  })
}

// 付款申请单-删除草稿
export async function getApplicationDraftsDeleteDraft(id) {
  return request({
    method: `DELETE`,
    url: `${apiHost}/payment/application/deleteDraft?id=${id}`,
  })
}


// 差旅费管理-草稿分页列表
export async function getTravelExpensesReimbursementDraftsList(pageSize,currentPage) {
  return request({
    method: `post`,
    url: `${apiHost}/travelExpensesReimbursement/draftsList/${pageSize}/${currentPage}`,
    data:{}
  })
}

// 差旅费管理-删除草稿
export async function getTravelExpensesReimbursementDeleteDraft(id) {
  return request({
    method: `DELETE`,
    url: `${apiHost}/travelExpensesReimbursement/deleteDraft?id=${id}`,
  })
}


// 领款管理-草稿分页列表
export async function getDrawDraftsList(pageSize,currentPage) {
  return request({
    method: `post`,
    url: `${apiHost}/draw/draftsList/${pageSize}/${currentPage}`,
    data:{}
  })
} 

// 领款管理-删除草稿
export async function getDrawDeleteDraft(id) {
  return request({
    method: `DELETE`,
    url: `${apiHost}/draw/deleteDraft?id=${id}`,
  })
}